"use strict";

emailBlast.classy.controller({
    name: "EmailPreviewModalController",
    inject: ["$scope", "$http", "$modal", "$sce", "$modalInstance", "EmailBlastService", "SchoolModelService"],
    init: function () {
    	this.$.$modalInstance = this.$modalInstance;
        this.$.EmailBlastService = this.EmailBlastService;
    	this.$.email = this.EmailBlastService.email;
        this.$.school = this.SchoolModelService.data[0];

    },
    send: function() {

        const schoolID = this.SchoolModelService.getSchoolID();
        const recipients = this.EmailBlastService.getRecipientList();
        const emailObj = this.EmailBlastService.email;
        const postValues = {
            email: angular.copy(emailObj),
            recipients: recipients
        };

        for (let i = 0; i < recipients.length; i++) {
            if (!recipients[i].admin) {
                recipients[i].send = 1;
            }
        }

        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/email/partials/confirmModal.html?v=" + versionNo,
            controller: "ConfirmModalController",
            resolve: {
                recipients: () => {
                    return recipients;
                },
                email: () => {
                    return postValues;
                }
            }
        }).result.then(
            () => {
                this.$modalInstance.close();
            }, // Success
            () => {} // Dismiss
        );
    }
});